/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import Card from "./Card";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: "top",
    },
    title: {
      display: false,
      text: "Chart.js Line Chart",
    },
    datalabels: {
      display: false,
    },
    tooltip: {
      backgroundColor: "#1f2937",
      titleColor: "#fff",
      bodyColor: "#d1d5db",
      borderColor: "#4b5563",
      borderWidth: 1,
      callbacks: {
        title: () => "Oqim tezligi",
        label: function (context) {
          const value = context.formattedValue;
          return `${value} m³/s`;
        },
      },
    },
  },
  elements: {
    point: {
      radius: 3,
      hoverRadius: 4,
      backgroundColor: "#4ADE80",
      borderWidth: 1,
      borderColor: "#fff",
    },
    line: {
      tension: 0.4,
    },
  },
  scales: {
    y: {
      grid: {
        color: "#e5e7eb",
        borderDash: [4, 4],
      },
      ticks: {
        color: "#6b7280",
      },
      beginAtZero: true,
    },
    x: {
      grid: {
        drawOnChartArea: false,
        color: "#d1d5db",
      },
      ticks: {
        color: "#6b7280",
      },
    },
  },
};

const labels = [
  "1",
  "3",
  "5",
  "7",
  "9",
  "11",
  "13",
  "15",
  "17",
  "19",
  "21",
  "23",
];

const Chart2 = ({ data }) => {
  const gradient = (ctx) => {
    const chart = ctx.chart;
    const { ctx: context, chartArea } = chart;

    if (!chartArea) return;

    const gradient = context.createLinearGradient(
        0,
        chartArea.top,
        0,
        chartArea.bottom
    );
    gradient.addColorStop(0, "rgba(34,197,94,0.3)");
    gradient.addColorStop(1, "rgba(34,197,94,0)");

    return gradient;
  };

  const datas = {
    labels,
    datasets: [
      {
        label: "m3/s",
        data: data,
        borderColor: "#22C55E",
        backgroundColor: gradient,
        fill: true,
      },
    ],
  };

  return (
      <Card>
        <div className='chart-box-all'>
          <div>
            {/* TUZATILDI: "kunlik" so'zi pastki indeks formatiga o'tkazilib, vizual muvozanatga keltirildi */}
            <h4 className='chart-title'>
              Ravotxoji G/U{" "}
              <span className='lower' style={{ opacity: 0.75, marginLeft: '4px' }}>
              soatlik (m<sup>3</sup>/s)
            </span>
            </h4>

            <Line options={options} data={datas} height={80} />
          </div>
        </div>
      </Card>
  );
};

export default Chart2;